import type {
  GetTasksQueryParamsV4,
  TasksFilterQueryParamsV4,
} from "@fartherfinance/frontend/api/TaskWorkflows/requests/getTasks";
import { SortOrder } from "@fartherfinance/frontend/api/Types";

export const TASKS_DEFAULT_PAGE = 1;
const TASKS_DEFAULT_PAGE_SIZE = 20;

export const TASK_STATUSES_ACTIVE = [
  "NOT_STARTED",
  "IN_PROGRESS",
  "WAITING_ON_CLIENT",
  "WAITING_ON_THIRD_PARTY",
  "WAITING_ON_ADVISOR",
  "WAITING_ON_CUSTODIAN",
];

export const TASK_STATUSES_COMPLETED = ["COMPLETED"];

export const TASK_STATUSES_ALL = [
  ...TASK_STATUSES_ACTIVE,
  ...TASK_STATUSES_COMPLETED,
  "CANCELED",
];

export const TASKS_DEFAULT_FILTERING_QUERY_PARAMS: TasksFilterQueryParamsV4 = {
  filterByTaskStatus: TASK_STATUSES_ACTIVE,
};

export const TASKS_DEFAULT_QUERY_PARAMS: GetTasksQueryParamsV4 = {
  page: TASKS_DEFAULT_PAGE,
  pageSize: TASKS_DEFAULT_PAGE_SIZE,
  sort: `${SortOrder.Ascending}dueDate`,
  ...TASKS_DEFAULT_FILTERING_QUERY_PARAMS,
};
